/* Urban Reptiles · movimiento nivel 2 (GSAP + ScrollTrigger). Solo presentación: no toca formularios ni carrito.
   Se desactiva por completo con "reducir movimiento". */
(function () {
  var capaIntro = document.getElementById('ur-intro');
  if (!window.gsap || !window.ScrollTrigger || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    if (capaIntro) capaIntro.remove();
    return;
  }
  gsap.registerPlugin(ScrollTrigger);
  var docEl = document.documentElement;
  docEl.classList.add('ur-gsap');
  // Los elementos que anima GSAP salen del sistema CSS de aparición (ur-rev) para no pisarse.
  function liberar(els) { els.forEach(function (el) { el.classList.add('ur-in'); var w = el.closest('.ur-rev'); if (w) w.classList.add('ur-in'); }); }

  /* 1 · Intro: el monograma se dibuja una vez por sesión y da paso al hero. */
  function intro() {
    var capa = document.getElementById('ur-intro');
    if (!capa) return;
    var visto = false;
    try { visto = sessionStorage.getItem('ur-intro') === '1'; } catch (e) {}
    if (visto || !document.querySelector('.ur-hero')) { capa.remove(); return; }
    try { sessionStorage.setItem('ur-intro', '1'); } catch (e) {}
    capa.hidden = false;
    var tl = gsap.timeline();
    tl.fromTo(capa.querySelector('svg'), { scale: 0.6, rotate: -10, opacity: 0 }, { scale: 1, rotate: 0, opacity: 1, duration: 0.9, ease: 'expo.out' }, 0)
      .fromTo(capa.querySelector('.ur-intro__aro'), { strokeDashoffset: 1 }, { strokeDashoffset: 0, duration: 0.9, ease: 'power2.inOut' }, 0.1)
      .to(capa.querySelector('svg'), { scale: 1.15, opacity: 0, duration: 0.45, ease: 'power2.in' }, 1.05)
      .to(capa, { yPercent: -100, duration: 0.6, ease: 'expo.inOut' }, 1.2);
    document.body.style.overflow = 'hidden';
    tl.eventCallback('onComplete', function () { document.body.style.overflow = ''; capa.remove(); ScrollTrigger.refresh(); });
  }

  /* 1b · Hero: la foto entra con revelado en máscara; 2 · parallax texto/foto. */
  function hero() {
    var h = document.querySelector('.ur-hero');
    if (!h) return;
    var foto = h.querySelector('.ur-hero__foto');
    gsap.fromTo(foto, { clipPath: 'inset(0 0 0 100%)' }, { clipPath: 'inset(0 0 0 0%)', duration: 1.3, ease: 'expo.out', delay: 0.15, clearProps: 'clipPath' });
    gsap.matchMedia().add('(min-width: 990px)', function () {
      gsap.to(h.querySelector('.ur-hero__txt'), { yPercent: 18, ease: 'none', scrollTrigger: { trigger: h, start: 'top top', end: 'bottom top', scrub: true } });
      gsap.to(foto.querySelector('img'), { yPercent: -12, ease: 'none', scrollTrigger: { trigger: h, start: 'top top', end: 'bottom top', scrub: true } });
    });
  }

  /* 2 · Línea-serpiente que recorre la home y conecta secciones (se dibuja con el scroll). */
  function serpiente() {
    var svg = document.getElementById('ur-serp-home');
    if (!svg) return;
    var path = svg.querySelector('path');
    var main = document.getElementById('MainContent');
    function medir() {
      var alto = main.scrollHeight;
      svg.setAttribute('viewBox', '0 0 100 ' + alto);
      svg.style.height = alto + 'px';
      svg.style.top = main.offsetTop + 'px';
      var d = 'M -5 ' + Math.round(alto * 0.12), y = alto * 0.12, x = -5, i = 0;
      while (y < alto * 0.92) {
        var ny = y + 420 + (i % 3) * 120, nx = i % 2 ? 108 : -8;
        d += ' C ' + (x + (nx - x) * 0.3) + ' ' + (y + (ny - y) * 0.4) + ', ' + (x + (nx - x) * 0.7) + ' ' + (y + (ny - y) * 0.6) + ', ' + nx + ' ' + ny;
        x = nx; y = ny; i++;
      }
      path.setAttribute('d', d);
      var L = path.getTotalLength();
      path.style.strokeDasharray = L;
      path.style.strokeDashoffset = L;
      return L;
    }
    var L = medir();
    gsap.to(path, { strokeDashoffset: 0, ease: 'none', scrollTrigger: { trigger: main, start: 'top top', end: 'bottom bottom', scrub: 0.6, invalidateOnRefresh: true } });
    ScrollTrigger.addEventListener('refreshInit', function () { L = medir(); });
  }

  /* 3 · Tarjetas en cascada con leve rotación; botones "imán". */
  function tarjetas() {
    document.querySelectorAll('.ur-grid').forEach(function (g) {
      var items = g.querySelectorAll('.ur-art, .ur-prod, .ur-valor');
      if (!items.length) return;
      liberar(items);
      gsap.fromTo(items, { y: 48, rotate: function (i) { return i % 2 ? 2 : -2; }, opacity: 0 }, { y: 0, rotate: 0, opacity: 1, duration: 0.9, ease: 'expo.out', stagger: 0.08, clearProps: 'transform,opacity',
        scrollTrigger: { trigger: g, start: 'top 82%', once: true } });
    });
    document.querySelectorAll('.ur-art__img img, .ur-prod__img img').forEach(function (img) {
      var card = img.closest('.ur-art, .ur-prod');
      card.addEventListener('mouseenter', function () { gsap.to(img, { scale: 1.07, duration: 0.8, ease: 'expo.out' }); });
      card.addEventListener('mouseleave', function () { gsap.to(img, { scale: 1, duration: 0.8, ease: 'expo.out' }); });
    });
    if (!window.matchMedia('(hover: hover)').matches) return;
    document.querySelectorAll('.ur-hero .button, .ur-cab .button, .ur-redes .button, .ur-legal .button').forEach(function (b) {
      b.addEventListener('mousemove', function (e) {
        var r = b.getBoundingClientRect();
        gsap.to(b, { x: (e.clientX - r.left - r.width / 2) * 0.25, y: (e.clientY - r.top - r.height / 2) * 0.35, duration: 0.4, ease: 'power3.out' });
      });
      b.addEventListener('mouseleave', function () { gsap.to(b, { x: 0, y: 0, duration: 0.7, ease: 'elastic.out(1, 0.4)' }); });
    });
  }

  /* 4 · Cinta de morfos ligada a la velocidad y dirección del scroll. */
  function cinta() {
    var pista = document.querySelector('.ur-cinta__pista');
    if (!pista) return;
    pista.style.animation = 'none';
    var ancho = pista.scrollWidth / 2, x = 0, vel = 0.6, dir = 1;
    ScrollTrigger.create({ onUpdate: function (self) { dir = self.direction; vel = Math.min(6, 0.6 + Math.abs(self.getVelocity()) / 600); } });
    gsap.ticker.add(function () {
      vel += (0.6 - vel) * 0.04;
      x -= vel * dir;
      if (x <= -ancho) x += ancho; if (x > 0) x -= ancho;
      pista.style.transform = 'translateX(' + x + 'px)';
    });
  }

  /* 6 · Galería: revelado por columnas y transición entre fotos del visor. */
  function galeria() {
    var gal = document.querySelector('.ur-gal');
    if (!gal) return;
    liberar(Array.prototype.slice.call(gal.children));
    gsap.fromTo(gal.children, { y: 60, opacity: 0, scale: 0.94 }, { y: 0, opacity: 1, scale: 1, duration: 1, ease: 'expo.out', stagger: { each: 0.07, from: 'start' }, clearProps: 'transform,opacity',
      scrollTrigger: { trigger: gal, start: 'top 80%', once: true } });
    var lb = document.querySelector('.ur-lb img');
    if (lb) {
      var obs = new MutationObserver(function () { gsap.fromTo(lb, { opacity: 0, scale: 0.96 }, { opacity: 1, scale: 1, duration: 0.45, ease: 'power2.out' }); });
      obs.observe(lb, { attributes: true, attributeFilter: ['src'] });
    }
  }

  /* 7 · Producto: la foto entra con zoom suave, el precio se "escribe", el botón de compra pulsa una vez. */
  function producto() {
    var media = document.querySelector('.product__media-wrapper');
    if (!media) return;
    gsap.fromTo(media, { opacity: 0, scale: 1.04 }, { opacity: 1, scale: 1, duration: 1.1, ease: 'expo.out', clearProps: 'all' });
    gsap.fromTo('.product__info-container > *', { y: 24, opacity: 0 }, { y: 0, opacity: 1, duration: 0.8, ease: 'expo.out', stagger: 0.07, delay: 0.15, clearProps: 'all' });
    var precio = document.querySelector('.product__info-container .price-item--regular, .product__info-container .price-item--sale');
    if (precio) {
      var txt = precio.textContent, num = txt.replace(/[^\d.,]/g, ''), n = parseFloat(num.replace(/,/g, ''));
      if (n && num.indexOf('.') > -1) {
        var pre = txt.slice(0, txt.indexOf(num)), post = txt.slice(txt.indexOf(num) + num.length), obj = { v: 0 };
        gsap.to(obj, { v: n, duration: 1.1, ease: 'power3.out', delay: 0.3, onUpdate: function () {
          precio.textContent = pre + obj.v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + post;
        }, onComplete: function () { precio.textContent = txt; } });
      }
    }
    var btn = document.querySelector('.product-form__submit');
    if (btn) gsap.fromTo(btn, { boxShadow: '0 0 0 0 rgba(35,31,32,0.35)' }, { boxShadow: '0 0 0 14px rgba(35,31,32,0)', duration: 1.2, ease: 'power2.out', delay: 1.2, repeat: 1 });
  }

  /* Secciones oscuras: los títulos entran con un deslizamiento leve (complemento del ur-rev existente). */
  function titulos() {
    document.querySelectorAll('.ur-cab h2, .ur-nhero h1, .ur-blog__cab h1').forEach(function (h) {
      liberar([h]);
      gsap.fromTo(h, { y: 28, opacity: 0 }, { y: 0, opacity: 1, duration: 0.9, ease: 'expo.out', clearProps: 'transform,opacity', scrollTrigger: { trigger: h, start: 'top 88%', once: true } });
    });
  }

  function init() { intro(); hero(); serpiente(); tarjetas(); cinta(); galeria(); producto(); titulos(); ScrollTrigger.refresh(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { ScrollTrigger.refresh(); });
})();
